import BaseView from '@/core/view/BaseView'

/**
 * ヘッダー
 */
class HeaderView extends BaseView {
  //

  // 表示状態かどうか
  private isShow = false

  //
  private body!: HTMLElement

  /**
   * コンストラクタ
   *
   */
  constructor() {
    super()

    // ヘッダー
    this.body = document.getElementsByTagName('body')![0]

    //
    this.listenResize()
    this.listenScroll()
  }

  /**
   *
   */
  private hide() {
    if (this.body!.classList.contains('show-header')) {
      this.body.classList.remove('show-header')
    }
    this.isShow = false
  }

  /**
   *
   */
  private show() {
    this.body!.classList.add('show-header')
    this.isShow = true
  }

  /**
   * リサイズイベントハンドラ
   *
   */
  public onResize(): void {
    // do nothing.
  }

  /**
   * 破壊
   */
  public dispose(): void {
    this.unListenResize()
    this.unListenScroll()
  }

  /**
   * スクロールイベントハンドラ
   */
  onScroll(): void {
    // スクロール位置
    const scrollY = this.getScrollPositionY()

    if (window.innerHeight / 4 * 3 < scrollY && !this.isShow) {
      this.show()
    } else if (window.innerHeight / 4 * 3 >= scrollY && this.isShow) {
      this.hide()
    }
  }
}

export default HeaderView
